import { Component } from '@angular/core';

import { Store } from '@ngrx/store';

import { MerchantSelectors } from '@merchant/store/merchant.slice';

@Component({
  selector: 'app-merchant-basic-data-readonly',
  templateUrl: './merchant-basic-data-readonly.component.html',
  styleUrls: ['./merchant-basic-data-readonly.component.scss'],
})
export class MerchantBasicDataReadonlyComponent {
  data$ = this.store.select(MerchantSelectors.selectActiveMerchant);

  constructor(private store: Store) {}
}
